import * as ActionTypes from "../constants/actionTypes"
import IDoctorProfile from "../interfaces/doctor/IDoctorProfile";


function init(): IDoctorProfile {
    return {} as IDoctorProfile
}

export const doctorProfileReducer = (
    state: IDoctorProfile = init(),
    action: any
): IDoctorProfile => {
    switch (action.type) {
        case ActionTypes.SET_DOCTOR_PROFILE:
            return {
                ...action.payload,
            }
        default:
            return state
    }
}